export default class TeacherInput { 
    coachName?: any | null
}